import useNoticeStore from '@/store/modules/notice';
import { useUserSotre } from '@/store/modules/user';
// 初始化
export const initSSE = (url: any) => {
  const userStore = useUserSotre();
  const { setReconnectSse } = userStore;
  const { state } = storeToRefs(userStore);
  // accessToken, reconnectSse
  const { VITE_APP_SSE, VITE_APP_CLIENT_ID } = import.meta.env;
  if (VITE_APP_SSE === 'false') {
    return;
  }
  url = `${url}?Authorization=Bearer ${state.value.accessToken}&clientid=${VITE_APP_CLIENT_ID}`;
  const { data, error, close } = useEventSource(url, [], {
    autoReconnect: {
      retries: 2,
      delay: 3000,
      onFailed() {
        close();
        console.log(state.value.reconnectSse, 'Failed to connect after 2 retries');
        if (state.value.reconnectSse) {
          // 自动连接两次后 重新获取token重连
          initSSE(`${import.meta.env.VITE_APP_PATH_SSE}/member/indexSse`);
          setReconnectSse(false);
        }
      }
    }
  });

  watch(error, () => {
    console.log('SSE connection error:', error.value);
    error.value = null;
  });

  watch(data, () => {
    if (!data.value) return;
    useNoticeStore().addNotice({
      message: data.value,
      read: false,
      time: new Date().toLocaleString()
    });
    data.value = null;
  });
};
